import Head from 'next/head';

import { COLORS } from '~/src/common/theme';
import { CSS_FONTS } from '~/src/common/theme/fonts';

export default () => (
  <Head>
    <meta httpEquiv="Content-Language" content="fr" />
    <meta name="google" content="notranslate" />
    <meta charSet="utf-8" />
    <meta
      name="viewport"
      content="viewport-fit=cover, width=device-width, initial-scale=1.0, shrink-to-fit=no"
    />

    <meta name="color-scheme" content="light" />
    <meta name="supported-color-schemes" content="light" />

    <meta name="theme-color" content={COLORS.NEUTRAL_DEFAULT} />
    <meta name="apple-mobile-web-app-status-bar-style" content={COLORS.NEUTRAL_DEFAULT} />
    <meta name="application-name" content="Mon Marché" />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <meta name="apple-mobile-web-app-status-bar-style" content="black" />
    <meta name="apple-mobile-web-app-title" content="Mon Marché" />

    <link rel="dns-prefetch" href="https://www.google-analytics.com" />
    <link rel="dns-prefetch" href="https://vc.hotjar.io" />

    <link rel="icon" type="image/png" href="/favicon/favicon-96x96.png" sizes="96x96" />
    <link rel="icon" type="image/svg+xml" href="/favicon/favicon.svg" />
    <link rel="shortcut icon" href="/favicon/favicon.ico" />
    <link rel="apple-touch-icon" sizes="180x180" href="/favicon/apple-touch-icon.png" />

    <style dangerouslySetInnerHTML={{ __html: CSS_FONTS }} />
  </Head>
);
